export const BLOCKED_PROPERTY_KEYS = new Set([
  'raw_input_text',
  'redacted_input_text',
  'input_text',
  'clinical_note',
  'transcript',
  'audio',
  'source_phrase',
  'search_query',
  'element_text',
  'link_href',
  'data_attributes',
  'original_value',
  'corrected_value',
  'patient_id',
  'visit_id',
  'patient_name',
  'first_name',
  'last_name',
  'full_name',
  'health_worker_name',
  'email',
  'phone',
  'phone_number',
  'dob',
  'date_of_birth',
  'national_id',
  'government_id',
  'next_of_kin',
  'patient_phone',
  '$name',
  '$first_name',
  '$last_name',
  '$email',
  '$phone',
]);

function isPlainObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
}

export function sanitizeProperties(value) {
  if (Array.isArray(value)) {
    return value.map(sanitizeProperties);
  }

  if (!isPlainObject(value)) {
    return value;
  }

  return Object.keys(value).reduce((clean, key) => {
    if (!BLOCKED_PROPERTY_KEYS.has(key.toLowerCase())) {
      clean[key] = sanitizeProperties(value[key]);
    }
    return clean;
  }, {});
}
